import { AccountService } from '@fp/interfaces/conversational/generated/api/account.service';
import { KlantConversationalConnectorComponent } from '@klant/conversational-connector/klant-conversational-connector.component';
import { KlantConversationalConnectorService } from '@klant/conversational-connector/klant-conversational-connector.service';
import { ConversationalChatErrorhandlerModule } from '@klant/conversational/conversational-chat-errorhandler/conversational-chat-errorhandler.module';
import { ConversationalChatInactivitypromptModule } from '@klant/conversational/conversational-chat-inactivityprompt/conversational-chat-inactivityprompt.module';
import { ConversationalChatOverlayMessageModule } from '@klant/conversational/conversational-chat-overlay-message/conversational-chat-overlay-message.module';
import { KlantConversationalModule } from '@klant/conversational/klant-conversational.module';

import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { inject, NgModule, provideAppInitializer } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, firstValueFrom } from 'rxjs';

import { ApAnalyticsService, ApPageviewDataService } from '@ap/analytics';
import { ApButtonComponent } from '@ap/button';
import { ApContentPipe, ApContentService } from '@ap/content';
import { ApErrorComponent } from '@ap/error';
import { API_KEY, BASE_PATH, ConversationalChatResource, KlantService } from '@ap/interface-apic-conversational-chat';
import { ApCookieService } from '@ap/persistence';

import { BASE_PATH as BASE_PATH_SEAMLY } from '../../fp/interfaces/apix-mono-klant-conversational/generated/variables';
import { ConversationalConfigStore } from '../../signal-stores/conversational-config-store/conversational-config.store';
import { ConversationalChatSkeletonComponent } from '../conversational/conversational-chat-skeleton/conversational-chat-skeleton.component';

export const getBasePathSeamly = (conversationalConfigStore: ConversationalConfigStore) => {
    return conversationalConfigStore.basePath();
};

/**
 * @ngdoc module
 * @name KlantConversationalModule
 **/
@NgModule({
    declarations: [KlantConversationalConnectorComponent],
    exports: [KlantConversationalConnectorComponent],
    imports: [
        ApButtonComponent,
        ApContentPipe,
        ApErrorComponent,
        KlantConversationalModule,
        ConversationalChatErrorhandlerModule,
        ConversationalChatInactivitypromptModule,
        ConversationalChatOverlayMessageModule,
        ConversationalChatSkeletonComponent
    ],
    providers: [
        AccountService,
        ApAnalyticsService,
        ApContentService,
        ApCookieService,
        ApPageviewDataService,
        ConversationalChatResource,
        KlantService,
        KlantConversationalConnectorService,
        {
            provide: BASE_PATH_SEAMLY,
            useFactory: getBasePathSeamly,
            deps: [ConversationalConfigStore]
        },
        { provide: BASE_PATH, useValue: '/services/{<CONVERSATIONAL_ENDPOINT>}/api' },
        { provide: API_KEY, useValue: '{<CONVERSATIONAL_APIKEY>}' },
        provideAppInitializer(() => {
            const conversationalConfigStore = inject(ConversationalConfigStore);
            return firstValueFrom(
                toObservable(conversationalConfigStore.seamlyConfiguration).pipe(
                    filter((seamlyConfiguration) => !!seamlyConfiguration.seamlyApiKey)
                ),
                { defaultValue: '' }
            );
        }),
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class KlantConversationalConnectorModule {}
